"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import $ from "jquery";
import _ from "underscore";
import ApiService from "../services/api_service";
import FactorInvoicesStore from "../stores/factor_invoices_store";
import DataStoreService from "./data_store_service";
class FactorInvoicesServiceClass {
  constructor() {
    __publicField(this, "store");
    __publicField(this, "inFlight");
    this.store = FactorInvoicesStore;
    this.inFlight = {};
  }
  ready() {
    var q = $.Deferred();
    q.resolve();
    return q.promise();
  }
  getWithId(id) {
    var existing = this.store.index[id];
    if (existing) {
      return Promise.resolve(this.store.index[id]);
    } else {
      return this.fetchWithIDAndReturnPromise(id);
    }
  }
  fetchInvoiceAndRelated(id) {
    return this.fetchWithID(id).then(
      ({
        factor_invoice: factorInvoice,
        factor_invoices: factorInvoices,
        verification,
        debtor_verification_status: debtorVerificationStatus,
        factor_client_invoice_submission: factorClientInvoiceSubmission
      }) => ({
        factorInvoice,
        factorInvoices,
        verification,
        debtorVerificationStatus,
        factorClientInvoiceSubmission
      })
    );
  }
  getFetchedWithId(id) {
    return this.store.index[id];
  }
  fetchWithID(id) {
    if (this.inFlight[id]) {
      return this.inFlight[id];
    }
    const promise = ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({ url: "/api/factor_invoices/" + id, cache: false, method: "GET" }).then(DataStoreService.responseHandler, _.identity).then((data) => {
        this.inFlight[id] = void 0;
        return data;
      }),
      null,
      { caller: "FactorInvoicesServiceClass.fetchWithID" }
    );
    this.inFlight[id] = promise;
    return promise;
  }
  fetchWithIDAndReturnPromise(id) {
    return this.fetchWithID(id).then((data) => data.factor_invoice);
  }
  rejectInvoice(invoiceId) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.post("/api/accounts_payable/factor_invoices/reject", {
        factor_invoices: [invoiceId]
      }).then(DataStoreService.responseHandler, _.identity).then((data) => _.first(data.factor_invoices)),
      null,
      { caller: "FactorInvoicesServiceClass.rejectInvoice" }
    );
  }
  unapproveInvoice(invoiceId) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.post("/api/accounts_payable/factor_invoices/unapprove_invoices", {
        factor_invoice: invoiceId
      }).then(DataStoreService.responseHandler, _.identity).then((data) => _.first(data.factor_invoices)),
      null,
      { caller: "FactorInvoicesServiceClass.unapproveInvoice" }
    );
  }
  markInvoiceAsPurchased(invoiceId) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.post("/api/accounts_payable/factor_invoices/mark_as_purchased", {
        factor_invoice: invoiceId
      }).then(DataStoreService.responseHandler, _.identity).then((data) => _.first(data.factor_invoices)),
      null,
      { caller: "FactorInvoicesServiceClass.markInvoiceAsPurchased" }
    );
  }
}
var factorInvoicesService = new FactorInvoicesServiceClass();
export default factorInvoicesService;
